import { Component, Inject, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ListModel } from '@app/common/models/list.model';
import { PageableList } from '@app/models/pageable.list';
import { ConstructionObjectNamePipe } from '@app/common/pipes/construction-object-name.pipe';
import { PageableListService } from '@app/common/services/pageable.list.service';
import { SettingsService } from '@app/ps/services/settings.service';
import { TableService } from '@app/ps/services/table.service';
import { StateService } from '@uirouter/angular';
import { AuthService } from '@app/common/services/auth.service';
import { ArrayUtils } from '@app/common/utils/array.utils';
import { TitleNamePipe } from '@app/common/pipes/title-name.pipe';
import { ParcelNumberPipe } from '@app/common/pipes/parcel-number.pipe';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { OccupationTypeModel } from '@app/ps/models/occupation-type.model';
import { ExportListService } from '@app/ps/services/export-list.service';
import { HelpService } from '@app/common/services/help.service';
import { APP_BRAND } from '@app/common/services/config.service';
import { DialogService } from '@app/common/services/dialog.service';
import { OccupationApproveComponent } from '@app/ps/occupations/components/occupation-approve/occupation-approve.component';
import { TooltipFinalSolutionStateComponent } from '@app/ps/occupations/components/tooltip-final-solution-state/tooltip-final-solution-state.component';
import { BrandService } from "@app/common/services/brand.service";
import { ApproveFinalSolutionTypeService } from "@app/common/services/approve-final-solution-type.service";
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';
import { ListService } from '@app/common/services/list.service';


@Component({
  selector: 'occupation-list',
  templateUrl: './occupation-list.component.html',
  styleUrls: ['./occupation-list.component.scss']
})
export class OccupationListComponent implements OnInit {

  static readonly COLLECTIONS = [
    'constructionObjects',
    'parcel.title.ownerships',
  ];

  readonly inputValidities = [
    { id: 'valid_with_parcel', name: 'Platný' },
    { id: 'invalid', name: 'Neplatný' },
  ];

  inputPriorities = [];
  inputFinalSolutionStates = [
    { id: FinalSolutionStateEnum.APPROVED, name: 'Schváleno' },
    { id: FinalSolutionStateEnum.REJECTED, name: 'Zamítnuto'},
    { id: FinalSolutionStateEnum.PENDING, name: 'Ke schválení'}
  ];
  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  occupationSolutionTypeOptions: any[] = [];
  list: ListModel<OccupationModel>;
  pageableList: PageableList;
  isArray = Array.isArray;
  occupationTypesPermanent: OccupationTypeModel[];
  occupationTypesTemporary: OccupationTypeModel[];
  rowspan: number;
  permanentOccupationRowspan: number;
  temporaryOccupationRowspan: number;
  exportEnable = true;
  settingsLoaded = false;
  helpIds = HelpService.HELP_IDS;
  settlement = false;
  priorityEnabled = false;

  constructor(
    @Inject(APP_BRAND) public APP_BRAND: any,
    public constructionObjectNamePipe: ConstructionObjectNamePipe,
    public titleNamePipe: TitleNamePipe,
    public parcelNumberPipe: ParcelNumberPipe,
    private pageableListService: PageableListService,
    private settingsService: SettingsService,
    private tableService: TableService,
    private stateService: StateService,
    private authService: AuthService,
    private brandService: BrandService,
    private exportListService: ExportListService,
    private dialogService: DialogService,
    public approveFinalSolutionTypeService: ApproveFinalSolutionTypeService,
    private listService: ListService,
  ) {
    this.onExport = this.onExport.bind(this);
  }

  async ngOnInit() {
    this.settingsLoaded = this.settingsService.getSettingsLoader() === null;
    if (!this.settingsLoaded) {
      this.settingsService.getSettingsLoader().then(() => this.settingsLoaded = true);
    }

    const occupationTypes = JSON.parse(JSON.stringify(this.authService.getActualProject().occupationTypes));

    const project = this.authService.getActualProject();

    this.settlement = this.brandService.isVisible('mpv') && project.type == 'ADDITIONAL';
    // TODO rozsireni pro typ akce 'INVEST'
    // this.settlement = this.brandService.isVisible('mpv') && (project.type == 'ADDITIONAL' || project.type == 'INVEST');

    if (this.settlement) {
      this.listService.fetchResult(
        this.listService.createList('occupation-solution-types', { limit: null })
      ).then((data) => {
        if (project.type === 'ADDITIONAL') this.occupationSolutionTypeOptions = data.list.slice(0, 6);
        // TODO rozsireni pro typ akce 'INVEST'
        // else this.occupationSolutionTypeOptions = data.list.slice(6);
      });
    }

    const inputPriority = project.occupationsPriority;
    this.priorityEnabled = inputPriority && inputPriority.enabled;
    if (this.priorityEnabled) {
      this.inputPriorities = inputPriority.categories
        .map((c, i) => ({ name: c.name, id: i }));
    }

    this.occupationTypesPermanent = _.filter(occupationTypes, (occupationType) => {
      return ['permanent'].includes(occupationType.category);
    });
    this.occupationTypesTemporary = _.filter(occupationTypes, (occupationType) => {
      return ['underOneYear', 'overOneYear'].includes(occupationType.category);
    });

    this.removeCommonStringFromTableHeading(this.occupationTypesPermanent, 'trvalý zábor');
    this.removeCommonStringFromTableHeading(this.occupationTypesTemporary, 'dočasný zábor');

    if (this.occupationTypesTemporary.length) {
      this.occupationTypesTemporary.push({ name: 'Délka nájmu (měsíc)', id: -1, number: undefined, category: 'rental_length' });
    }

    this.rowspan = (this.shouldHaveSecondRow() ? 2 : 1);
    this.permanentOccupationRowspan = (this.shouldHaveSecondRow() && this.shouldDrawSecondRowOf(this.occupationTypesPermanent) ? 1 : 2);
    this.temporaryOccupationRowspan = (this.shouldHaveSecondRow() && this.shouldDrawSecondRowOf(this.occupationTypesTemporary) ? 1 : 2);

    this.initializeList();
  }

  uiOnParamsChanged(changedParams, transition) {
    this.pageableList && this.pageableList.uiOnParamsChanged(changedParams, transition);
  }

  onExport() {
    this.exportEnable = false;
    const filter = {...this.list.filter};
    filter.filters.loadCollections.push('cases');

    const occupationTypes = this.authService.getActualProject().occupationTypes;
    const columnDefinitions = [];

    for (const occupationType of occupationTypes) {
      columnDefinitions.push({
        name: occupationType.name,
        key: 'zabvym',
        formatByEval: 'var result = listItem.getZabtyp() == ' + occupationType.number + ' ? (listItem.getZabvym() + "") : ""; result;',
      });
    }

    if (this.occupationTypesTemporary.length) {
      columnDefinitions.push({
        name: 'Délka nájmu (měsíc)',
        key: 'rentalLength'
      });
    }

    return this.exportListService
      .exportList('occupations', 'occupations', filter, {}, false, columnDefinitions)
      .then(() => {
        new Promise(resolve => setTimeout(() => resolve(), 5000)).then(() => {
          this.exportEnable = true;
        });
      });
  }

  removeCommonStringFromTableHeading(heading: OccupationTypeModel[], commonString: string) {
    const headingNames = _.concat(_.map(heading, 'name'), commonString);
    const replaceFn = (str) => str.toLowerCase().replace(ArrayUtils.getLongestCommonSubstring(headingNames, true), '').trim();
    const wouldBeEmpty = heading.some((cur) => replaceFn(cur.name) === '');

    if (wouldBeEmpty && heading.length > 1) { // don't prevent rows merging in projects with just one occupation type
      return;
    }

    _.forEach(heading, (obj) => {
      obj.name = replaceFn(obj.name);
    });
  }

  shouldDrawSecondRowOf(what: OccupationTypeModel[]): boolean {
    return !(what.length === 1 && what[0].name === '');
  }

  shouldHaveSecondRow(): boolean {
    const temp = [ ...this.occupationTypesPermanent, ...this.occupationTypesTemporary ];
    return temp.filter((item) => item.name).length > 0;
  }

  hideColumn(columnId: string) {
    return this.settingsService.shouldHideColumn('occupations', columnId);
  }

  onApproveOccupation(occupation: OccupationModel) {
    const dialog = this.dialogService.open(OccupationApproveComponent, {
      data: { occupation },
    });

    const sub = dialog.afterClosed.subscribe((result) => {
      sub.unsubscribe();
      if (result) {
        Object.assign(occupation, result);
      }
    });
  }

  private getDefaultFilter() {
    return {
      filters: {
        validOrWithCase: true,
        areaId: { values: [], negation: false },
        titleId: {},
        parcelId: {},
        occupationTypeId: {},
        constructionObjectStageId: {},
        constructionObjectId: { values: [], negation: false },
        validityParcelCase: {},
        priorityIndex: { values: []},
        finalSolutionTypeId: {},
        finalSolutionState: {},
        searchText: { values: [{ id: '' }]},
        loadCollections: OccupationListComponent.COLLECTIONS
      },
      sortOrder: { sortBy: 'parcel.title.lv', direction: 'asc' },
    };
  }

  private initializeList() {
    this.pageableList = this.pageableListService.get(
      'occupations',
      this.getDefaultFilter(),
      'occupationsFilter'
    );

    this.list = this.pageableList.list;
    this.pageableList.load();
  }
  readonly tooltipFinalSolutionStateComponent = TooltipFinalSolutionStateComponent;
}
